/**
 * Значок счёта — как значок категории: иконка в цвете счёта на подложке того
 * же тона. Либо логотип банка на белой плашке: у логотипа свои цвета, и
 * красить его нельзя.
 *
 * Один компонент на всё приложение — список «Счета», выбор счёта в записи, в
 * фильтрах, в выписке. Иначе в одном месте счёт узнаётся по логотипу, а в
 * другом — по серой карточке, и узнавание пропадает ровно там, где выбирают
 * в спешке.
 */
import { accountIcon, type Account } from '@skoka/core';
import { bankOf } from './banks.js';
import { CategoryGlyph, CATEGORY_COLORS, type CategoryColor } from './category-icon.js';

const KNOWN = new Set<string>(CATEGORY_COLORS);

/** Цвет по виду счёта — пока человек не выбрал свой. */
const KIND_COLOR: Record<Account['kind'], CategoryColor> = {
  debit: 'blue', cash: 'green', savings: 'amber', credit_card: 'violet',
  deposit: 'amber', brokerage: 'blue', custodial: 'amber',
};

export function accountColor(a: Pick<Account, 'kind' | 'color'>): CategoryColor {
  return a.color && KNOWN.has(a.color) ? a.color as CategoryColor : KIND_COLOR[a.kind] ?? 'gray';
}

/** Значок по значению поля: имя иконки или `bank:<id>`. */
export function IconGlyph({ icon, color, size = 'm' }: { icon: string; color: CategoryColor; size?: 'f' | 's' | 'm' | 'l' }) {
  const bank = bankOf(icon);
  if (bank) {
    return <span className={`catico bank s-${size}`} aria-hidden="true"><img src={bank.src} alt="" /></span>;
  }
  return <CategoryGlyph icon={icon} color={color} size={size} />;
}

export function AccountGlyph({ account, size = 'm' }: {
  account: Pick<Account, 'kind' | 'icon' | 'color'>;
  size?: 'f' | 's' | 'm' | 'l';
}) {
  return <IconGlyph icon={accountIcon(account)} color={accountColor(account)} size={size} />;
}
